// Import Dependencies
import React, { useEffect } from "react";

// Import Aos library
import Aos from "aos";
import "aos/dist/aos.css";

// Import Components
import Layout from "./Layout/Layout";

function App() {
  useEffect(() => {
    Aos.init({
      duration: 1800,
      offset: 100,
    });
  }, []);

  return (
    <>
      <Layout />
    </>
  );
}

export default App;
